import { countryOptions } from 'components/helper/countryPhoneCode';
import SelectInput from 'components/input/SelectInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import {
  otherNonImmigrantStatusOptions,
  otherVisaTypeOptions,
  pLanedVisaTypeOptions,
  visaTypeOptions,
  visaUnitedStatesOptions,
} from 'components/helper/appConfig';
import YesNoSwitch from 'components/input/YesNoSwitch';
import DatePickerInput from 'components/input/DatePicker';
import { csuCountry } from 'components/helper/helper';
import TextInput from 'components/input/textInput';
import { stateAndCounty } from 'components/helper/stateAndCounty';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import Grid from '@mui/joy/Grid';

interface Props {
  formik: any;
  check: any;
  isMobile?: boolean;
  disabled?: boolean;
}

const General = (props: Props) => {
  const { check, isMobile = false, disabled = false } = props;
  return (
    <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
      <Grid xs={6}>
        <SelectInput
          logo="span-cm-logo"
          form={props.formik}
          option={[
            '',
            'U.S. citizen or U.S. national',
            'U.S. dual citizen',
            'U.S. permanent resident (green card holder)',
            'U.S. resident',
            'Citizen of non-U.S.country',
            'Other non-immigrant status'
          ]}
          label="Select your citizenship status*"
          isSatTest={true}
          name={'current_citizenship_status'}
          values={props.formik.values.current_citizenship_status}
          onChange={(e: any) => {
            props.formik.handleChange(e);
            if (e?.target?.value !== 'Other non-immigrant status') {
              props.formik.setFieldValue('csu_info.other_non_immigrant_status', '');
            }
          }}
          isMissing={!props.formik.values.current_citizenship_status && check}
          disabled={disabled}
        />
      </Grid>

      {props.formik.values.current_citizenship_status === 'Other non-immigrant status' && (
        <Grid xs={isMobile ? 12 : 6}>
          <SelectInput
            logo="span-csu-logo"
            form={props.formik}
            option={otherNonImmigrantStatusOptions}
            label="Select the value that best describes your current status*"
            isSatTest={true}
            name="csu_info.other_non_immigrant_status"
            values={props.formik.values.csu_info?.other_non_immigrant_status}
            onChange={props.formik.handleChange}
            isMissing={!props.formik.values.csu_info?.other_non_immigrant_status && check}
            disabled={disabled}
          />
        </Grid>
      )}

      {[
          'U.S. dual citizen',
          'U.S. permanent resident (green card holder)',
          'U.S. resident',
          'Citizen of non-U.S.country',
      ].includes(props.formik.values.current_citizenship_status) && (
        <>
          <Grid xs={12}>
            <AutocompleteInput
              logo="span-cm-logo"
              multiple={true}
              onChange={(val: any) => {
                props.formik.setFieldValue('list_citizenship', val);
              }}
              option={countryOptions}
              label={'List Citizenship(s) other than the U.S. *'}
              name={'list_citizenship'}
              values={props.formik.values.list_citizenship}
              isMissing={!props.formik.values?.list_citizenship?.length && check ? true : false}
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12}>
            <div className="text-field-light fw-bold span-csu-logo">International Agent</div>
          </Grid>
          <Grid xs={12}>
            <YesNoSwitch
              // logo="span-csu-logo"
              label="Are you currently working with a representative or agency?*"
              onChange={props.formik.handleChange}
              name="csu_info.current_working_with_representative_or_agency"
              values={props.formik.values.csu_info?.current_working_with_representative_or_agency}
              isMissing={
                !props.formik.values.csu_info?.current_working_with_representative_or_agency &&
                check
              }
              disabled={disabled}
            />
          </Grid>
          {props.formik.values.csu_info?.current_working_with_representative_or_agency ===
            'true' && (
            <>
              <Grid xs={isMobile ? 12 : 6}>
                <SelectInput
                  className="mt-3"
                  logo="span-csu-logo"
                  label="Representative Type*"
                  isSatTest={true}
                  option={['', 'Agency Sponsored', 'Government', 'Other Sponsored', 'University']}
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_type"
                  values={props.formik.values.csu_info?.representative_type}
                  isMissing={!props.formik.values.csu_info?.representative_type && check}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={49}
                  label="Representative Name*"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_name"
                  values={props.formik.values.csu_info?.representative_name}
                  isMissing={!props.formik.values.csu_info?.representative_name && check}
                  className="mt-3"
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={49}
                  label="Representative Street Address"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_street_address"
                  values={props.formik.values.csu_info?.representative_street_address}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={49}
                  label="Representative Street Address Line 2"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_street_address_line_2"
                  values={props.formik.values.csu_info?.representative_street_address_line_2}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={49}
                  label="Representative City"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_city"
                  values={props.formik.values.csu_info?.representative_city}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={49}
                  label="Representative State/Province"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_state"
                  values={props.formik.values.csu_info?.representative_state}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={10}
                  type="number"
                  label="Representative Postal Code"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_postal_code"
                  values={props.formik.values.csu_info?.representative_postal_code}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <SelectInput
                  logo="span-csu-logo"
                  label="Representative Country*"
                  option={csuCountry}
                  onChange={props.formik.handleChange}
                  isMissing={!props.formik.values.csu_info?.representative_country && check}
                  name="csu_info.representative_country"
                  values={props.formik.values.csu_info?.representative_country}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={20}
                  label="Representative Phone*"
                  type="phoneNumber"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_phone"
                  values={props.formik.values.csu_info?.representative_phone}
                  isMissing={!props.formik.values.csu_info?.representative_phone && check}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  logo="span-csu-logo"
                  countText={49}
                  label="Representative Email*"
                  onChange={props.formik.handleChange}
                  name="csu_info.representative_email"
                  values={props.formik.values.csu_info?.representative_email}
                  isMissing={!props.formik.values.csu_info?.representative_email && check}
                  disabled={disabled}
                />
              </Grid>
            </>
          )}

          <Grid xs={12}>
            <div className="text-field-light fw-bold mt-3">International Applicant Details</div>
          </Grid>
          <div className="w-100" style={{marginLeft: '-0.375rem'}}>
            <div className="row normal align-items-flex-end mb-4">
              <div className="col-md-6">
                <TextInput
                  countText={4}
                  logo="span-csu-logo"
                  label="What year did you (or do you plan to) move to the U.S.?"
                  type="number"
                  onChange={props.formik.handleChange}
                  name="csu_info.year_move_to_US"
                  values={props.formik.values.csu_info?.year_move_to_US}
                  isMissing={!props.formik.values.csu_info?.year_move_to_US && check}
                  disabled={disabled}
                />
              </div>
              <div className="col-md-6">
                <AutocompleteInput
                  logo="span-uc-csu-logo"
                  form={props.formik}
                  option={countryOptions}
                  label={'What is your main country of Citizenship*'}
                  isCuScuLogo={true}
                  name={'country'}
                  values={props.formik.values.country}
                  feedback={
                    props.formik.touched.country &&
                    props.formik.errors.country && (
                      <span className="text-danger">{props.formik.errors.country}</span>
                    )
                  }
                  isMissing={!props.formik.values.country && check}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
          

          {props.formik.values.country !== 'United States of America' && (
            <>
              {!['U.S. dual citizen'].includes(props.formik.values.current_citizenship_status) && (
                <>
                <Grid xs={isMobile ? 12 : 6}>
                  <GroupRadioButton
                    name="citizenship_status"
                    mdCol={12}
                    verticalLayout={true}
                    values={props.formik.values.citizenship_status}
                    onChange={props.formik.handleChange}
                    options={[
                      {
                        value: 'Legal U.S. permanent resident (green card)',
                      },
                      {
                        value: 'Refugee',
                      },
                      {
                        value:
                          'Non-immigrant/foreign visa (you have a visa or will be applying for one)',
                      },
                    ]}
                    label="What will your citizenship status be on the date you submit this application? *"
                    isMissing={!props.formik.values.citizenship_status && check}
                    disabled={disabled}
                  />
                </Grid>
                <Grid xs={12}>
                  {props.formik.values.citizenship_status ===
                    'Legal U.S. permanent resident (green card)' && (
                    <Grid container spacing={2}>
                      <Grid xs={12}>
                        <SelectInput
                          name="csu_info.permanent_residence_status"
                          label="Select the value that best describes your permanent residence status:"
                          values={props.formik.values.csu_info?.permanent_residence_status}
                          onChange={props.formik.handleChange}
                          option={[
                            'Permanent Resident/Green Card holder',
                            'Applicant for Permanent Residence (I-485 receipt)',
                            'Temp Proof of Permanent Residence (I-551 stamp)',
                          ]}
                          disabled={disabled}
                        />
                      </Grid>
                      <Grid xs={12} md={6}>
                        <SelectInput
                          option={csuCountry}
                          name="csu_info.country"
                          label="Country of Citizenship"
                          values={props.formik.values.csu_info?.country}
                          onChange={props.formik.handleChange}
                          disabled={disabled}
                        />
                      </Grid>
                      <Grid xs={12} md={6}>
                        <DatePickerInput
                          name="csu_info.date"
                          label="Permanent Resident / Green Card Date Issued*"
                          values={props.formik.values.csu_info?.date}
                          onChange={(e) => props.formik.setFieldValue('csu_info.date', e)}
                          isMissing={!props.formik.values.csu_info?.date && check}
                          disabled={disabled}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                {props.formik.values.citizenship_status === 'Refugee' && (
                  <Grid xs={12}>
                    <SelectInput
                      option={csuCountry}
                      name="csu_info.country"
                      label="Country of Citizenship*"
                      values={props.formik.values.csu_info?.country}
                      onChange={props.formik.handleChange}
                      isMissing={!props.formik.values.csu_info?.country && check}
                      disabled={disabled}
                    />
                  </Grid>
                )}
                {props.formik.values.citizenship_status ===
                  'Non-immigrant/foreign visa (you have a visa or will be applying for one)' && (
                  <>
                    <Grid xs={12}>
                      <YesNoSwitch
                        values={props.formik.values.have_us_visa}
                        onChange={props.formik.handleChange}
                        label="Do you currently have a U.S. visa? *"
                        name="have_us_visa"
                        isMissing={!props.formik.values.have_us_visa && check}
                        disabled={disabled}
                      />
                    </Grid>
                    {props.formik.values.have_us_visa === 'false' && (
                      <>
                        <Grid xs={12}>
                          <SelectInput
                            logo="span-uc-logo"
                            label="Which type of U.S. visa will you apply for (or have applied for)? *"
                            option={visaTypeOptions}
                            name="type_of_apply_for_us_visa"
                            onChange={props.formik.handleChange}
                            values={props.formik.values.type_of_apply_for_us_visa}
                            isMissing={!props.formik.values.type_of_apply_for_us_visa && check}
                            disabled={disabled}
                          />
                        </Grid>
                        <Grid xs={12}>
                          <SelectInput
                            option={csuCountry}
                            name="csu_info.country"
                            label="Country of Citizenship"
                            values={props.formik.values.csu_info?.country}
                            onChange={props.formik.handleChange}
                            disabled={disabled}
                          />
                        </Grid>
                      </>
                    )}
                    {props.formik.values.have_us_visa === 'true' && (
                      <>
                        <Grid xs={12}>
                          <SelectInput
                            label="Currently held United States Visa*"
                            option={visaUnitedStatesOptions}
                            name="csu_info.currently_held_united_states_visa"
                            onChange={props.formik.handleChange}
                            values={props.formik.values.csu_info?.currently_held_united_states_visa}
                            isMissing={
                              !props.formik.values.csu_info?.currently_held_united_states_visa && check
                            }
                            logo="span-cm-logo"
                            disabled={disabled}
                            />
                        </Grid>

                        <Grid xs={12}>
                          <SelectInput
                            logo="span-uc-logo"
                            label="Current visa type *"
                            option={visaTypeOptions}
                            name="type_of_current_us_visa"
                            onChange={props.formik.handleChange}
                            values={props.formik.values.type_of_current_us_visa}
                            isMissing={!props.formik.values.type_of_current_us_visa && check}
                            disabled={disabled}
                            />
                        </Grid>

                        <Grid xs={12}>
                          <SelectInput
                            logo="span-csu-logo"
                            label="Visa Type"
                            option={otherVisaTypeOptions}
                            name="csu_info.visa_type"
                            onChange={props.formik.handleChange}
                            values={props.formik.values.csu_info?.visa_type}
                            disabled={disabled}
                            />
                        </Grid>
                        <Grid xs={6}>
                          <TextInput
                            countText={18}
                            className="py-3"
                            logo="span-cm-logo"
                            label="Visa number*"
                            onChange={props.formik.handleChange}
                            name="csu_info.visa_number"
                            values={props.formik.values.csu_info?.visa_number}
                            isMissing={!props.formik.values.csu_info?.visa_number && check}
                            disabled={disabled}
                            />
                        </Grid>
                        <Grid xs={6}>
                          <DatePickerInput
                            logo="span-csu-logo"
                            label="Date Issued*"
                            name="csu_info.date_issued"
                            values={props.formik.values.csu_info?.date_issued}
                            onChange={(e) => props.formik.setFieldValue('csu_info.date_issued', e)}
                            isMissing={!props.formik.values.csu_info?.date_issued && check}
                            disabled={disabled}
                            />
                        </Grid>
                      </>
                    )}

                    <Grid xs={12}>
                      <DatePickerInput
                        name="csu_info.visa_date_issued"
                        label="Visa Date Issued"
                        values={props.formik.values.csu_info?.visa_date_issued}
                        onChange={(e) => props.formik.setFieldValue('csu_info.visa_date_issued', e)}
                        disabled={disabled}
                        />
                    </Grid>

                    <Grid xs={12}>
                      <YesNoSwitch
                        onClear={() => props.formik.setFieldValue('will_you_have_different_visa', '')}
                        name="will_you_have_different_visa"
                        values={props.formik.values.will_you_have_different_visa}
                        onChange={props.formik.handleChange}
                        label="By the time you attend UC, will you have a different visa?*"
                        isMissing={!props.formik.values.will_you_have_different_visa && check}
                        disabled={disabled}
                        />
                    </Grid>
                    <Grid xs={12}>
                      <SelectInput
                        logo="span-csu-logo"
                        onChange={props.formik.handleChange}
                        label="Planned visa type *"
                        option={pLanedVisaTypeOptions}
                        name="planned_visa_type"
                        values={props.formik.values.planned_visa_type}
                        isMissing={!props.formik.values.planned_visa_type && check}
                        disabled={disabled}
                        />
                    </Grid>
                    {props.formik.values.will_you_have_different_visa === 'false' && (
                      <Grid xs={12}>
                        <SelectInput
                          label="Visa Type"
                          option={visaUnitedStatesOptions}
                          name="csu_info.other_visa_type"
                          onChange={props.formik.handleChange}
                          values={props.formik.values.csu_info?.other_visa_type}
                          isMissing={!props.formik.values.csu_info?.other_visa_type && check}
                          disabled={disabled}
                        />
                      </Grid>
                    )}
                  </>
                )}
                </> 
              )}

              <Grid xs={12}>
                <YesNoSwitch
                  logo="span-csu-logo"
                  values={props.formik.values.csu_info?.require_F1_Visa_or_J1_visa}
                  onChange={props.formik.handleChange}
                  label="Do you have or will you require an F1 Visa (student) or J1 Visa (exchange) to study at the California State University (CSU)?*"
                  name="csu_info.require_F1_Visa_or_J1_visa"
                  isMissing={
                    !props.formik.values.csu_info?.require_F1_Visa_or_J1_visa && check
                  }
                  disabled={disabled}
                />
              </Grid>

              {props.formik.values.csu_info?.require_F1_Visa_or_J1_visa === 'true' ? (
                <>
                  <Grid xs={12}>
                    <GroupRadioButton
                      logo="span-csu-logo"
                      values={props.formik.values.csu_info?.visa_you_have_at_CSU}
                      onChange={props.formik.handleChange}
                      name="csu_info.visa_you_have_at_CSU"
                      label="Which student visa do you have, or will you have when you study at the CSU?"
                      options={['F1 (Student)', 'J1 (Exchange)']}
                      disabled={disabled}
                    />
                  </Grid>
                  <Grid xs={12}>
                    <DatePickerInput
                      logo="span-csu-logo"
                      label="Date Issued (if you have already been issued a student visa)"
                      name="csu_info.visa_you_have_at_CSU_date_issued"
                      values={
                        props.formik.values.csu_info?.visa_you_have_at_CSU_date_issued
                      }
                      onChange={(e) =>
                        props.formik.setFieldValue('csu_info.visa_you_have_at_CSU_date_issued', e)
                      }
                      disabled={disabled}
                    />
                  </Grid>
                </>
              ) : (
                <Grid xs={12}>
                  <SelectInput
                    logo="span-csu-logo"
                    label="What U.S. State/Possession do you regard as your permanent home?*"
                    option={Object.keys(stateAndCounty)}
                    name="csu_info.us_state_you_regard_as_permanent_home"
                    onChange={props.formik.handleChange}
                    values={
                      props.formik.values.csu_info?.us_state_you_regard_as_permanent_home
                    }
                    isMissing={
                      !props.formik.values.csu_info?.us_state_you_regard_as_permanent_home
                    }
                    disabled={disabled}
                  />
                </Grid>
              )}
              
            </>
          )}
        </>
      )}

      <Grid xs={12}>
        <div className="text-dark span-csu-logo">
          If you are currently an active F-1 student, enter your SEVIS ID:
        </div>
        <div className="text-dark">Student Must enter this information manually on the app</div>
      </Grid>
      <Grid xs={12}>
        <div className="fs-5 py-1">Social Security</div>
        <div
          className="text-field-light mt-3"
          style={{
            backgroundColor:
              !props.formik.values.is_have_us_social_security_number && check ? '#FFEBEB' : '',
            display: 'inline-block',
          }}
        >
          Do you have a U.S. Social Security number or an Individual Taxpayer Identification Number
          (ITIN)?*
        </div>
        <div className="text-field-light uc-coallition-flag">
          If you apply for financial aid, we use the Social Security number or ITIN you provide to
          match your application to your Free Application for Federal Student Aid (FAFSA) or
          California Dream Act application. See 'Help' for more information on the additional uses
          of the Social Security number.
        </div>
        <YesNoSwitch
          className="my-3 uc-coallition-flag"
          name={'is_have_us_social_security_number'}
          values={props.formik.values.is_have_us_social_security_number}
          onChange={props.formik.handleChange}
          disabled={disabled}
        />
        <div className="text-field-light">
          To protect your privacy, we do not ask for your social security number, however you'll
          need to input this information directly on the application when it is requested.
        </div>
      </Grid>
    </Grid>
  );
};

export default General;
